import UnitToggleSegment from '../UnitToggleSegment';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const UnitToggle: FunctionComponent<Props> = ({
    className = '',
    onSelect,
    options,
    selectedUnit,
    testId = TEST_ID,
    unitLabels
}) => (
    <HorizontalContainer className={`${styles.unitToggle} ${className}`} testId={testId}>
        {options.map(unit => (
            <UnitToggleSegment
                isSelected={unit === selectedUnit}
                key={unit}
                label={unitLabels[unit] ?? unit}
                onSelect={onSelect}
                unit={unit}
            />
        ))}
    </HorizontalContainer>
);

export default UnitToggle;
